import { Controller } from "@hotwired/stimulus"

// Shows and hides a collapsible section, such as the mobile author list in a
// sidebar. Toggles the open class on the element, which the CSS styles
// against, and keeps aria-expanded on the button in step.
export default class extends Controller {
  static targets = ["button"]
  static classes = ["open"]

  connect() {
    this.#sync()
  }

  toggle() {
    this.element.classList.toggle(this.openClass)
    this.#sync()
  }

  #sync() {
    this.buttonTarget.setAttribute("aria-expanded", this.element.classList.contains(this.openClass))
  }
}
